import get from 'transmute/get';
import { QUICK_LINKS } from '../constants/attachmentTypes';
import { getAttachments } from './getAttachments';
import { getQuickLinks as getQuickLinksFromAttachment } from './quickLinksAttachmentGetters';
export const getQuickLinksAttachment = commonMessage => {
  const attachments = getAttachments(commonMessage);
  if (!attachments) {
    return undefined;
  }
  return attachments.find(attachmentObject => get('@type', attachmentObject) === QUICK_LINKS);
};
export const getQuickLinks = message => {
  const quickLinksAttachment = getQuickLinksAttachment(message);
  const options = getQuickLinksFromAttachment(quickLinksAttachment);
  return options !== null && options !== void 0 && options.toJS ? options.toJS() : options || [];
};
export const getHasQuickLinks = message => {
  const quickLinksAttachment = getQuickLinksAttachment(message);
  return Boolean(quickLinksAttachment);
};